import googleAnalytics from './api/google-analytics';
import ga4 from './api/ga4';
import matomo from './api/matomo';
import environment from '../environment/environment';

const trackers = [];

function initialize() {
  const env = environment.get();

  if (env.analytics) {
    const trackerConfigs = env.analytics.trackers;
    // default is google analytics for now: change this in 2023!
    const googleAnalyticsTrackers = trackerConfigs.filter((t) => (t.type === undefined || t.type === 'google-analytics'));
    const ga4Trackers = trackerConfigs.filter((t) => (t.type === 'ga4'));
    const matomoTrackers = trackerConfigs.filter((t) => t.type === 'matomo' && t.url !== undefined && t.url.length > 1);

    matomoTrackers.forEach((tracker, count) => {
      const isLast = ((matomoTrackers.length - 1) === count);
      const mTracker = matomo.initialize(tracker, count, isLast);
      trackers.push(mTracker);
    });

    googleAnalyticsTrackers.forEach((tracker, count) => {
      const isLast = ((googleAnalyticsTrackers.length - 1) === count);
      const gTracker = googleAnalytics.initialize(tracker, count, isLast);
      trackers.push(gTracker);
    });

    ga4Trackers.forEach((tracker, count) => {
      const isLast = ((ga4Trackers.length - 1) === count);
      const ga4Tracker = ga4.initialize(tracker, count, isLast);
      trackers.push(ga4Tracker);
    });
  }
}

// set and setDimension should be called before trackPageView.
// trackEvent should only be called after trackPageView.
// this is according to spec from 3rdparty-vendors / api
function set(param, value) {
  if (document.documentElement.classList.contains('trackable')
    || document.documentElement.dataset.trackingEnabled === 'true') {
    trackers.forEach((tracker) => {
      tracker.set(param, value);
    });
  }
}

function setDimension(dimensionId, value) {
  if (document.documentElement.classList.contains('trackable')
    || document.documentElement.dataset.trackingEnabled === 'true') {
    trackers.forEach((tracker) => {
      tracker.setDimension(dimensionId, value);
    });
  }
}

function trackEvent(category, action, options) {
  if (document.documentElement.classList.contains('trackable')
    || document.documentElement.dataset.trackingEnabled === 'true') {
    trackers.forEach((tracker) => {
      tracker.trackEvent(category, action, options || {});
    });
  }
}

function trackPageView() {
  if (document.documentElement.classList.contains('trackable')
    || document.documentElement.dataset.trackingEnabled === 'true') {
    trackers.forEach((tracker) => {
      tracker.trackPageView();
    });
  }

  // additonal error tracking for all pages for all styleguides
  if (document.documentElement.dataset.trackingError) {
    trackEvent('Error page', 'Called', {
      label: `${document.documentElement.dataset.trackingError} » ${window.location.href}`,
    });
  }
}

export default {
  initialize,
  set,
  setDimension,
  trackPageView,
  trackEvent,
};
